var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "lc-pagination" }, [
    _c(
      "ul",
      { staticClass: "pagination" },
      [
        _c(
          "li",
          {
            class: ["page-item", "fixed", { disabled: _vm.selectedPage == 1 }],
          },
          [
            _c(
              "a",
              {
                staticClass: "page-link",
                on: {
                  click: function ($event) {
                    return _vm.select(_vm.selectedPage - 1)
                  },
                },
              },
              [_c("span", { staticClass: "mdi mdi-chevron-left" })]
            ),
          ]
        ),
        _vm._l(_vm.pageNumbers, function (pageNum) {
          return _c(
            "li",
            {
              key: pageNum,
              class: ["page-item", { active: _vm.selectedPage == pageNum }],
            },
            [
              _c(
                "a",
                {
                  staticClass: "page-link",
                  class: { disabled: pageNum == "..." },
                  on: {
                    click: function ($event) {
                      return _vm.select(pageNum)
                    },
                  },
                },
                [_vm._v(_vm._s(pageNum))]
              ),
            ]
          )
        }),
        _c(
          "li",
          {
            class: [
              "page-item",
              "fixed",
              { disabled: _vm.selectedPage == _vm.pagesCnt },
            ],
          },
          [
            _c(
              "a",
              {
                staticClass: "page-link",
                on: {
                  click: function ($event) {
                    return _vm.select(_vm.selectedPage + 1)
                  },
                },
              },
              [_c("span", { staticClass: "mdi mdi-chevron-right" })]
            ),
          ]
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }